import { Component, OnDestroy, OnInit } from '@angular/core';
import { AcmicService, HeaderComponent, MapfreCardComponent, MapfreLoadingComponent } from '@mapfre-design-library/src/public_api';
import { Router } from '@angular/router';
import { BillingNewService } from '@services/common/billing-new.service';
import { BillingDataService } from '@services/data-services/billing-data.service';
import { PolicyDataService } from '@services/data-services/policy-data.service';
import { tap, catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { ErrorRedirectionService } from '@services/error-service/error-redirection.service';
import { CommonModule } from '@angular/common';

declare let OneInc: any;
@Component({
  selector: 'app-make-payment-widget',
  templateUrl: './make-payment-widget.component.html',
  styleUrls: ['./make-payment-widget.component.scss'],
  imports: [CommonModule, MapfreLoadingComponent, MapfreCardComponent, HeaderComponent]
})


export class MakePaymentWidgetComponent implements OnInit, OnDestroy {
  isAcmic: boolean;
  container: any;
  portalOne: any;
  policy: any;
  loading = true;
  billingDetails: any;
  referenceData3: string;
  paymentPayload: any;
  minAmountDue: number;
  accountBalance: number;


  constructor(
    private acmicService: AcmicService,
    private router: Router,
    private billingNewService: BillingNewService,
    private billingDataService: BillingDataService,
    private policyDataService: PolicyDataService,
    private errorRedirectionService: ErrorRedirectionService
  ) {
    this.isAcmic = false;
  }

  calculateAmounts() {
    if (this.policy.billingDetails[0] && this.policy.hasPriorYearBalance) {
      this.accountBalance =
        this.policy.billingDetails[0].outstandingbalance +
        this.policy.priorYearBalance.theAmount;
      this.minAmountDue =
        this.policy.billingDetails[0].amountStillDue +
        this.policy.priorYearBalance.theAmount;
    } else {
      this.accountBalance = this.policy.billingDetails[0].outstandingbalance;
      this.minAmountDue = this.policy.billingDetails[0].amountStillDue;
    }
  }


  onPayByCardBilling() {
     this.calculateAmounts();
    this.paymentPayload = {
      operation: 'makePayment',
      minAmountDue: this.minAmountDue || this.policy.billingDetails[0]?.minAmountDue,
      accountBalance: this.accountBalance || this.policy.billingDetails[0]?.outstandingbalance,
      referenceNumber: this.policy.policynumber.policyNumber,
      clientReferenceData1: this.policy.policynumber.policyNumber, // policyNumber
      clientReferenceData3: 'B2C Guest',
      clientReferenceData4: 'GUEST',
      clientReferenceData5: this.policy?.policyState, //MA or AAA based on company
    };

    this.billingNewService.getV2OneIncTokensForGuest(this.paymentPayload)
      .pipe(
        tap(res => {
          if (!res?.PortalOneSessionKey || !res?.Token) {
            throw new Error('Missing session or token in response');
          }
        }),
        catchError(err => {
          // console.error('Payment init failed', err);
          this.errorRedirectionService.errorRedirectHandler(err);
          return EMPTY;
        })
      )
      .subscribe(res => {
        this.portalOne.run({
          sessionId: res.PortalOneSessionKey,
          accessTokenId: res.Token,
          displayMode: 'Inline',
          allowClosing: true,
          loadingIndication: false,
        });
      });
  }

  subscribeToEvents(container: HTMLElement) {
    if (!container) {
      return;
    }
    container.addEventListener('portalOne.load', () => {
      console.log('modal loaded');
      this.loading = false;
    });
    container.addEventListener('portalOne.paymentComplete', (data: any) => {
      const paymentCompletePayload = JSON.stringify({
        paymentStatus:        'Success',
        paymentAmount:        data.detail?.paymentAmount,
        transactionId:        data.detail?.transactionId,
        clientReferenceData1: data.detail?.clientReferenceData1 ?? this.paymentPayload?.clientReferenceData1,
        clientReferenceData3: data.detail?.clientReferenceData3 ?? this.paymentPayload?.clientReferenceData3,
        clientReferenceData4: data.detail?.clientReferenceData4 ?? this.paymentPayload?.clientReferenceData4,
      });
      this.billingNewService.postPaymentEventGuest(paymentCompletePayload).subscribe();
    });

    // container.addEventListener('portalOne.paymentCanceled', () => {
    //   console.log('closed callback');
    //   // this.loading=true;
    //   this.router.navigate(['make-payment'])
    // });
    
    container.addEventListener('portalOne.error', (err: any) => {
      const paymentErrorPayload = JSON.stringify({
        paymentStatus:        'Failed',
        errorCode:            err.detail?.errorCode,
        errorMessage:         err.detail?.Description ?? err.detail?.errorMessage,
        clientReferenceData1: this.paymentPayload?.clientReferenceData1,
        clientReferenceData3: this.paymentPayload?.clientReferenceData3,
        clientReferenceData4: this.paymentPayload?.clientReferenceData4,
      });
      this.billingNewService.postPaymentEventGuest(paymentErrorPayload).subscribe();
    });
    container.addEventListener('portalOne.unload', () => {
      console.log(' portalOne.unload');
      this.router.navigate(['make-payment'])
    });
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();

    this.billingDataService.$billingDetails.subscribe((currentBill) => {
      this.billingDetails = currentBill;
    });
    this.policyDataService.$policyDetails.subscribe((policy) => {
      this.policy = policy[0];
    });
    this.container = document.getElementById('portalOneContainer');
    this.portalOne = new OneInc.PortalOne(
      this.container,
      this.subscribeToEvents(this.container)
    );
    this.onPayByCardBilling();
  }
  ngOnDestroy() {
    if (this.container) {
      const newConatiner = this.container.cloneNode(true) as HTMLElement;
      this.container.replaceWith(newConatiner);
      this.container = null
    }
  }
}
